import { Link } from '@design-system/link';
import React, { FC } from 'react';

import { BurgerCloserProps } from './models';

export const BurgerCloser: FC<BurgerCloserProps> = ({
  burgerCloseIcon,
  burgerCloseLabel,
  isJS,
}) =>
  !isJS ? (
    <Link
      className="cds-global-header__burger-closer"
      variant="subtle-icon"
      href="#close-menu"
      size="large"
      iconSuffix={{
        props: burgerCloseIcon,
      }}
    >
      {burgerCloseLabel}
    </Link>
  ) : null;
